import { ReactElement, useState } from 'react';
import Button, { Color } from 'lib/Button';
import Modal, { ModalSize } from 'lib/Modal';
import LiveboardVisuals from 'components/common/LiveboardVisuals';
import { DealStatus } from 'components/common/types/Deal.types';
import { thoughtspot } from 'config';
import { DealLineItemData } from 'components/common/types/DealItem';
import { filterByDealId, filterByCampaignId } from 'components/pages/Insights/LabsReportDropdown/utils';
import usePendoTracking from 'customHooks/usePendoTracking';

export type DeliveryStatsRendererProps = {
  data: DealLineItemData;
};

const DeliveryStatsRenderer = ({ data }: DeliveryStatsRendererProps): ReactElement | null => {
  const [isOpen, setIsOpen] = useState(false);
  const { getPendoDataId } = usePendoTracking();

  const onButtonClick = (e: React.MouseEvent<HTMLButtonElement>): void => {
    e.preventDefault();
    setIsOpen(true);
  };

  if (data?.bookingStatusCode !== DealStatus.LIVE) return null;

  return (
    <>
      <Button
        onClick={onButtonClick}
        label="Quick Delivery Stats"
        color={Color.TERTIARY}
        dataPendoId={getPendoDataId('Quick delivery stats button')}
      />
      <Modal isOpen={isOpen} onClose={() => setIsOpen(false)} size={ModalSize.LARGE}>
        <LiveboardVisuals
          liveboardId={thoughtspot.quickDeliveryStatsLiveboardId}
          visualId={thoughtspot.quickDeliveryStatsVisualizationId}
          frameStyles="h-[600px]"
          filterByOptions={
            data?.isChildRow ? [filterByDealId(data?.lineId ?? '')] : [filterByCampaignId(data?.dealId ?? '')]
          }
        />
      </Modal>
    </>
  );
};

export default DeliveryStatsRenderer;
